import { Component, OnChanges, SimpleChanges, inject, input, booleanAttribute } from '@angular/core';
import { ApiService, ControlableObjectBasicInfo, ControllableObjectDetailDataCrate, UnitStatusEnum } from '@cue/api';
import { catchError, map } from 'rxjs/operators';
import { Observable, of, tap } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import {
  cueRaindrops,
  cueSun,
  cueExclamation,
  cueScreen,
  IconComponent,
  cueInfo,
  cueCheckCircle,
  cueMute,
  cueMinusCircle,
  cuePlusCircle,
  cueWarning,
} from '@cue/ui/icons';
import { ControllableObjectComponent } from '../controllable-object/controllable-object.component';
import { translation } from '@cue/translations';
import { TranslocoPipe } from '@jsverse/transloco';
import { Pack } from '@cue/data';

@Component({
  selector: 'cue-controllable-objects',
  imports: [AsyncPipe, ControllableObjectComponent, TranslocoPipe, IconComponent],
  templateUrl: './controllable-objects.component.html',
  styleUrls: ['./controllable-objects.component.scss'],
})
export class ControllableObjectsComponent implements OnChanges {
  ignoreErrors = input<boolean, boolean | 'true' | 'false'>(false, {
    transform: booleanAttribute,
  });
  private apiService = inject(ApiService);
  ICONS = {
    cueRaindrops,
    cueSun,
    cueExclamation,
    cueInfo,
    cueScreen,
    cueCheckCircle,
    cueMute,
    cueMinusCircle,
    cuePlusCircle,
    cueWarning,
  };

  protected showAtLeastOneUnitNOtAvailable: boolean;
  protected readonly translation = translation;

  qrCodeId = input.required<string>();
  qrCodeListOfResource = input.required<string[]>();
  objectList = input.required<ControlableObjectBasicInfo[]>();
  controllableObjectDetailList$: Observable<Pack<ControllableObjectDetailDataCrate>>[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['objectList'] && this.objectList()?.length > 0) {
      this.loadObjectsDetailList();
    }
  }

  private loadObjectsDetailList() {
    this.objectList().forEach((object) => {
      this.controllableObjectDetailList$.push(this.loadObjectsDetail(object));
    });
  }

  private loadObjectsDetail(
    objectData: ControlableObjectBasicInfo
  ): Observable<Pack<ControllableObjectDetailDataCrate>> {
    const url = '/api/control/object/' + objectData.id + '?qrCodeId=' + objectData.qrCodeId;

    return this.apiService
      .call<any, ControllableObjectDetailDataCrate>({
        url: url,
        method: 'get',
      })
      .pipe(
        tap(() => {
          this.showAtLeastOneUnitNOtAvailable = false;
        }),
        map((r) => ({
          loading: false,
          data: {
            data: {
              ...r.data,
              objectId: objectData.id,
            },
            showInDetail: r.showInDetail,
            unitStatus: r.unitStatus,
          },
          error: null,
        })),
        tap((x) => {
          if (x?.data?.unitStatus === UnitStatusEnum.NotAvailable) {
            this.showAtLeastOneUnitNOtAvailable = true;
            console.error(`Object ${objectData.name} with ID: ${objectData.id} is not available`);
          }
        }),
        catchError((e) => {
          console.error('Error during load controllable object detail:');
          console.error(e);
          return of({
            loading: false,
            data: null,
            error: e,
          });
        })
      );
  }
}
